import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import routes from './routes/routes';
import PasswordProtection from './components/PasswordProtection/PasswordProtection';

const renderRoutes = (routes) => {
  return routes.map((route, index) => {
    const { path, element, children, index: isIndex } = route;
    
    if (isIndex) {
      return <Route key={`route-${index}`} index element={element} />;
    }
    
    if (children) {
      return (
        <Route key={`route-${index}`} path={path} element={element}>
          {renderRoutes(children)}
        </Route>
      );
    }
    
    return <Route key={`route-${index}`} path={path} element={element} />;
  });
};

// Public routes that don't require password protection
const PUBLIC_ROUTES = ['/terms', '/privacy', '/disclaimer', '/responsible-gambling'];

const AppContent = ({ isPasswordProtected, hasAccess, handleAccessGranted }) => {
  const location = useLocation();
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);

  // Track page views on route change for Google Analytics
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  // Show password protection if enabled, access not granted, and not on a public route
  if (isPasswordProtected && !hasAccess && !isPublicRoute) {
    return <PasswordProtection onAccessGranted={handleAccessGranted} />;
  }

  return (
    <div className="App">
      <Routes>
        {renderRoutes(routes)}
      </Routes>
    </div>
  );
};

const App = () => {
  const isPasswordProtected = process.env.REACT_APP_PASSWORD_PROTECTED === 'true';
  const [hasAccess, setHasAccess] = useState(!isPasswordProtected);

  // Check if user already has access (stored in sessionStorage)
  useEffect(() => {
    if (isPasswordProtected) {
      const accessGranted = sessionStorage.getItem('dev_access_granted') === 'true';
      setHasAccess(accessGranted);
    }
  }, [isPasswordProtected]);

  const handleAccessGranted = () => {
    setHasAccess(true);
  };

  return (
    <AuthProvider>
      <Router>
        <AppContent 
          isPasswordProtected={isPasswordProtected}
          hasAccess={hasAccess}
          handleAccessGranted={handleAccessGranted}
        />
      </Router>
    </AuthProvider>
  );
}

export default App;